module.exports = __webpack_public_path__ + "static/RobotoCondensed-Regular-72a5403236c502e4ab8436ed841e5e65.woff";